module.exports = __webpack_public_path__ + "static/media/gift01_ja.db1c8ee5.png";